import { render, staticRenderFns } from "./false_positives.vue?vue&type=template&id=6e6a7720"
import script from "./false_positives.vue?vue&type=script&lang=js"
export * from "./false_positives.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports